import "./style.css";

export default class   TwoColumnText {
    static selector = ".two-column-text";
  
    constructor(block) {
      
      this.block = block;
      
    }
}